import * as R from 'ramda';
import localeKeys from './../../../locales/keys';
import { FormHelper, i18n, UnsavedChangesPromptActions } from 'invision-core';
import memoize from 'lodash/memoize';
import { BLANK_PAYMENT_INSTRUMENT } from '../makePayment/make.payment.constants';
import { CurrentCustomerIdSelector, CurrentServiceIdSelector } from '../../../reducers/selectors/customer.selectors';
import { CustomerTopUpsIsFetchingTopUpsSelector, CustomerTopUpsIsSubmittingTopUpSelector, CustomerTopUpsServiceOptionsSelector, CustomerTopUpsSelectorByServiceIdentifier, LastAttemptErrorSelector } from '../../../reducers/selectors/customer.top.ups.selectors';
import { DefaultPaymentMethodSelector, IsRetrievingEwalletDataSelector, PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector, SelectedPaymentMethodSelector } from '../../../reducers/selectors/customer.ewallet.selectors';
import { getAvailableTopUps, submitTopUp } from '../../../reducers/actions/customer.top.ups.actions';
import { selectPaymentMethod, retrieveWalletAndSelectDefaultPaymentMethod } from '../../../reducers/actions/customer.ewallet.actions';
function TopUpsController($ngRedux, $state, $stateParams, $window, $scope, $timeout, invPhoneFilter) {
  var _this = this;
  var disconnectRedux,
    errorPopupApi = null;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      currentCustomerId: CurrentCustomerIdSelector(store),
      defaultPaymentMethod: DefaultPaymentMethodSelector(store),
      isFetchingTopUps: CustomerTopUpsIsFetchingTopUpsSelector(store),
      isRetrievingPaymentInstruments: IsRetrievingEwalletDataSelector(store),
      isSubmittingTopUp: CustomerTopUpsIsSubmittingTopUpSelector(store),
      lastAttemptError: LastAttemptErrorSelector(store),
      paymentInstruments: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
      selectedPaymentInstrument: SelectedPaymentMethodSelector(store),
      serviceId: CurrentServiceIdSelector(store),
      topUpServices: CustomerTopUpsServiceOptionsSelector(store),
      topUpsByServiceId: CustomerTopUpsSelectorByServiceIdentifier(store)
    };
  };
  this.$onInit = function () {
    _this.LocaleKeys = localeKeys;
    var controllerActions = {
      getAvailableTopUps: getAvailableTopUps,
      retrieveWalletAndSelectDefaultPaymentMethod: retrieveWalletAndSelectDefaultPaymentMethod,
      submitTopUp: submitTopUp,
      selectPaymentMethod: selectPaymentMethod,
      unregisterUnsavedChanges: UnsavedChangesPromptActions.unregisterUnsavedChanges
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.actions.getAvailableTopUps(_this.state.currentCustomerId);
    _this.actions.retrieveWalletAndSelectDefaultPaymentMethod({
      customerId: _this.state.currentCustomerId
    });
  };
  this.submitTopUpOrder = function () {
    if (!_this.validate()) {
      return false;
    }
    var submissionData = {
      serviceIdentifier: _this.state.serviceId,
      pricingPlanId: _this.selectedTopUpId,
      paymentInstrumentId: _this.state.selectedPaymentInstrument.Id
    };
    _this.actions.unregisterUnsavedChanges('TopUps.topUpsForm');
    _this.actions.submitTopUp(_this.state.currentCustomerId, submissionData).catch(function () {
      errorPopupApi.open();
    });
  };
  this.validate = function () {
    var errorLookup = {
      selectedTopUpId: {
        required: i18n.translate(_this.LocaleKeys.TOP_UPS.TOP_UP_REQUIRED)
      }
    };
    _this.errors = FormHelper.formHasErrors(_this.topUpsForm.$error, errorLookup).filter(function (error, index, filtered) {
      return filtered.find(function (existing) {
        return existing.description === error.description;
      }) === error;
    });
    return _this.errors.length === 0;
  };
  this.handleFormChange = function () {
    $timeout(_this.validate);
  };
  this.isShowingLoadingIndicator = function () {
    return _this.state.isFetchingTopUps || _this.state.isSubmittingTopUp || _this.state.isRetrievingPaymentInstruments;
  };
  this.errorPopupConfig = {
    onRegisterApi: function onRegisterApi(event) {
      errorPopupApi = event.api;
    }
  };
  this.handleCloseErrorPopup = function () {
    errorPopupApi.close();
  };
  this.formatBillingAddressCity = function () {
    var billingAddress = R.path(['selectedPaymentInstrument', 'BillingAddress'], _this.state);
    if (!billingAddress) {
      return '';
    }
    var substitutions = {
      city: billingAddress.City,
      state: billingAddress.State,
      zip: billingAddress.PostalCode
    };
    return i18n.translate(_this.LocaleKeys.CITY_STATE_ZIP, substitutions);
  };
  this.formatSelectedExpirationDate = function () {
    var card = R.path(['selectedPaymentInstrument', 'CreditCard'], _this.state);
    if (!card || !card.ExpirationMonth || !card.ExpirationYear) {
      return '';
    }
    return "".concat(card.ExpirationMonth, "/").concat(card.ExpirationYear);
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  this.onServiceSelect = function (service) {
    $state.go('.', {
      serviceId: service.id
    });
  };
  this.changePaymentInstrument = function () {
    _this.actions.unregisterUnsavedChanges('TopUps.topUpsForm');
    $state.go('.paymentinstrument');
  };
  this.goBack = function () {
    $state.go('^.dashboard');
  };
  this.topUpsAvailable = function () {
    return _this.topUpPlans().length;
  };
  this.topUpPlans = function () {
    return _this.state.topUpsByServiceId ? _this.state.topUpsByServiceId[_this.state.serviceId].TopUpPricingPlans : [];
  };
  this.selectedTopUp = function () {
    return _this.selectedTopUpId ? _this.topUpPlans().find(function (topup) {
      return topup.Id === _this.selectedTopUpId;
    }) : null;
  };
  this.serviceListOptions = memoize(function (services, selected) {
    var topUps = [];
    for (var topUp in services) {
      topUps.push(services[topUp]);
    }
    var topUpOptions = topUps.map(function (item) {
      return {
        text: invPhoneFilter(item.FriendlyName ? item.FriendlyName : item.ServiceIdentifier),
        selected: item.ServiceIdentifier === selected,
        id: item.ServiceIdentifier
      };
    });
    return topUpOptions;
  });
  this.toggleDescription = function (topup) {
    _this.selectedDescription = _this.selectedDescription === topup.Id ? null : topup.Id;
  };

  // New Payment Instrument related controller methods and helper functions.
  this.instrumentPopup = {
    config: {
      onRegisterApi: function onRegisterApi(event) {
        _this.instrumentPopup.api = event.api;
      }
    },
    onClose: function onClose() {
      _this.instrumentPopup.api.close();
      _this.instrumentPopup.show = false;
    },
    open: function open() {
      _this.instrumentPopup.paymentInstrument = BLANK_PAYMENT_INSTRUMENT;
      _this.instrumentPopup.show = true;
      $timeout(_this.instrumentPopup.api.open);
    },
    isEditing: false,
    show: false,
    paymentInstrument: null
  };
}
export default {
  template: require('./top.ups.html'),
  bindings: {},
  controller: TopUpsController,
  controllerAs: 'TopUps'
};